// AccessGuard.jsx
import { Navigate, Outlet } from 'react-router-dom';

const AccessGuard = ({ roles }) => {
	const token = localStorage.getItem("token");
	const userRole = localStorage.getItem("role");

	if (!token) {
		return <Navigate to="/auth/login" replace />;
	}

	if (roles && !roles.includes(userRole)) {
		return <Navigate to="/unauthorized" replace />;
	}

	return <Outlet />;
};

export default AccessGuard;